import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';
import EoiApply from '../components/eoi-apply/index.vue';
import EoiReview from '../components/eoi-review/index.vue';
import Committee from '../components/committee/index.vue';
import CMPMain from '@/components/cmp-main/index.vue';
import Dashboard from '@/components/dashboard/index.vue';
import { RouteN } from '@/constants/route-name';
import AutoLogin from '@/components/auto-login/index.vue';
import Logout from '@/components/logout/index.vue';
import NoAccess from '@/components/no-access/index.vue';
import General from '@/components/general/index.vue';
import NoFileSelected from '@/components/no-file-selected/index.vue';

const routes: Array<RouteRecordRaw> = [
  {
    path: RouteN.CMP.LoginPage.p,
    name: RouteN.CMP.LoginPage.n,
    component: AutoLogin,
  },
  {
    path: RouteN.CMP.LogoutPage.p,
    name: RouteN.CMP.LogoutPage.n,
    component: Logout,
  },
  {
    path: RouteN.NoAccess.p,
    name: RouteN.NoAccess.n,
    component: NoAccess,
  },
  {
    path: RouteN.NoFileSelected.p,
    name: RouteN.NoFileSelected.n,
    component: NoFileSelected,
  },
  {
    path: RouteN.CMP.Main.p,
    meta: { requiresAuth: true },
    redirect: { name: RouteN.CMP.Dashboard.n },
    name: RouteN.CMP.Main.n,
    component: CMPMain,
    children: [
      {
        path: RouteN.CMP.Dashboard.p,
        name: RouteN.CMP.Dashboard.n,
        component: Dashboard
      },
      {
        path: RouteN.CMP.EoiApply.p,
        name: RouteN.CMP.EoiApply.n,
        component: EoiApply
      },
      {
        path: RouteN.CMP.EoiReview.p,
        name: RouteN.CMP.EoiReview.n,
        component: EoiReview
      },
      {
        path: RouteN.CMP.Committee.p,
        name: RouteN.CMP.Committee.n,
        component: Committee
      },
      {
        path: RouteN.CMP.General.p,
        name: RouteN.CMP.General.n,
        component: General
      }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
